import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import BoltIcon from '@mui/icons-material/Bolt';
export function FinalCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(86391);
  return <section className="py-14 px-6 bg-brand-choco-deep text-brand-cream border-t border-brand-gold/20" data-id="element-64">
      <div className="max-w-4xl mx-auto text-center" data-id="element-65">
        <div className="inline-block bg-brand-burgundy text-white px-6 py-3 rounded-full font-bold mb-6 shadow-lg" data-id="element-66">
          ⏰ EL PRECIO CIERRA EN: [{hours} hs : {minutes} min : {seconds} seg]
        </div>

        <div className="space-y-6 mb-8" data-id="element-67">
          {/* Option 1 Compact */}
          <div className="bg-brand-choco p-6 rounded-xl border border-brand-gold/20 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-68">
            <div className="text-left" data-id="element-69">
              <h3 className="font-serif font-bold text-xl text-brand-cream" data-id="element-70">
                📘 MEGAPACK VELAS QUE SE COMEN
              </h3>
              <p className="text-sm text-brand-cream/70" data-id="element-71">
                Tomo 1 + Tomo 2 + 4 Bonos
              </p>
            </div>
            <div className="flex flex-col items-center md:items-end" data-id="element-72">
              <div className="text-brand-cream/50 line-through text-sm" data-id="element-73">
                ~$51.000~
              </div>
              <div className="text-2xl font-bold text-brand-cream mb-2" data-id="element-74">
                $19.990 ARS
              </div>
              <a href="#" className="bg-brand-cream text-brand-choco-deep hover:bg-white font-bold py-2 px-6 rounded-lg transition-colors text-sm w-full md:w-auto text-center" data-id="element-75">
                ➔ [ QUIERO MI MEGAPACK ]
              </a>
            </div>
          </div>

          {/* Option 2 Compact */}
          <div className="bg-brand-choco p-6 rounded-xl border-2 border-brand-gold flex flex-col md:flex-row items-center justify-between gap-6 relative" data-id="element-76">
            <div className="absolute -top-3 left-6 bg-brand-gold text-brand-choco-deep text-xs font-bold px-2 py-1 rounded uppercase" data-id="element-77">
              Más elegido
            </div>
            <div className="text-left mt-2 md:mt-0" data-id="element-78">
              <h3 className="font-serif font-bold text-xl text-brand-gold" data-id="element-79">
                🏆 MEGAPACK + EMBAJADORA
              </h3>
              <p className="text-sm text-brand-cream/70" data-id="element-80">
                Tomo 1 + Tomo 2 + 4 Bonos + Kit de Negocio
              </p>
            </div>
            <div className="flex flex-col items-center md:items-end" data-id="element-81">
              <div className="text-brand-cream/50 line-through text-sm" data-id="element-82">
                ~$69.000~
              </div>
              <div className="text-2xl font-bold text-brand-gold mb-2" data-id="element-83">
                $29.990 ARS
              </div>
              <a href="#" className="bg-brand-gold text-brand-choco-deep hover:bg-brand-amber font-bold py-2 px-6 rounded-lg transition-colors text-sm w-full md:w-auto text-center shadow-md" data-id="element-84">
                ➔ [ QUIERO EL MEGAPACK + KIT DE NEGOCIO ]
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-cream/60 font-medium" data-id="element-85">
          <span className="flex items-center gap-1" data-id="element-86">
            <LockIcon fontSize="small" data-id="element-87" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-88">
            <BoltIcon fontSize="small" data-id="element-89" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-90">
            <ShieldIcon fontSize="small" data-id="element-91" /> Garantía 7 días
          </span>
        </div>
      </div>
    </section>;
}